import styled from 'styled-components'
import LeftBar from '../home/components/leftBar'
import RadarPanel from './RadarPanel'

const Page = styled.div`
    display: flex;
    height: 100vh;
    overflow: hidden !important;
`

export default function RadarFornecedor() {
    return (
        <Page>
            <LeftBar />
            <RadarPanel />
        </Page>
    )
}
